import { useState } from 'react';

// Map regional bookmaker keys to consolidated logo filenames
const LOGO_FILENAME_MAP: Record<string, string> = {
  // Betfair Exchange - all regions use same logo
  betfair_ex_uk: 'betfair_ex',
  betfair_ex_eu: 'betfair_ex',
  betfair_ex_au: 'betfair_ex',
  // Betfair Sportsbook
  betfair_sb_uk: 'betfair_sb',
  // LeoVegas - all regions use same logo
  leovegas_se: 'leovegas',
  // Unibet - all regions use same logo
  unibet_uk: 'unibet',
  unibet_fr: 'unibet',
  unibet_it: 'unibet',
  unibet_nl: 'unibet',
  unibet_se: 'unibet',
  // Ladbrokes - all regions use same logo
  ladbrokes_uk: 'ladbrokes',
  ladbrokes_au: 'ladbrokes',
  // Winamax - all regions use same logo
  winamax_de: 'winamax',
  winamax_fr: 'winamax',
};

interface BookmakerLogoProps {
  bookmakerKey: string;
  bookmakerTitle: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

export default function BookmakerLogo({ bookmakerKey, bookmakerTitle, className = '', size = 'medium' }: BookmakerLogoProps) {
  const [imageError, setImageError] = useState(false);
  const logoFilename = LOGO_FILENAME_MAP[bookmakerKey] || bookmakerKey;
  const logoPath = `/bookmaker-logos/${logoFilename}.png`;

  // Define sizes
  const sizeMap = {
    small: { width: '32px', height: '32px' },
    medium: { width: '80px', height: '24px' },
    large: { width: '100px', height: '32px' }
  };

  const dimensions = sizeMap[size];

  if (imageError) {
    // Fallback to abbreviated text if image fails to load
    const abbreviation = bookmakerTitle
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 3);

    return (
      <span
        className={className}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size === 'small' ? '32px' : dimensions.width,
          height: size === 'small' ? '32px' : dimensions.height,
          fontSize: size === 'small' ? '10px' : '11px',
          fontWeight: 700,
          color: '#a8b2d1',
          background: 'rgba(168, 178, 209, 0.1)',
          borderRadius: '4px',
        }}
      >
        {abbreviation}
      </span>
    );
  }

  return (
    <img
      src={logoPath}
      alt={bookmakerTitle}
      className={className}
      onError={() => setImageError(true)}
      style={{
        maxWidth: dimensions.width,
        maxHeight: dimensions.height,
        objectFit: 'contain',
      }}
    />
  );
}
